import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { PricingPlanDecorator } from "lib/decorators/index";

export default new (class PricingPlansRepository extends BaseRepository {
  findAll() {
    const bucket = this.getBucket("pricingPlans.index");
    const request$ = this.api
      .get(`/pricing_plans`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((pricingPlans) => pricingPlans.map((pricingPlan) => new PricingPlanDecorator(pricingPlan)));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/PricingPlansRepository.js